<template>
  <div class="q-pa-xs col-12 col-sm-6">
    <label class="field-label">{{ label }}{{ required ? '*' : '' }}</label>
    <QInput
      ref="field"
      outlined
      v-model="localValue"
      :placeholder="placeholder"
      :rules="getRules()"
      :type="type"
      v-on:blur="onBlur"
      :readonly="readonly"
      lazy-rules
      @focus="onFocus"
      :autofocus="autoFocus"
    />
  </div>
</template>

<script>
import { QInput } from 'quasar';
/**
 * This component represents common UI for an input field with label
 */
export default {
  name: 'InputCardField',
  props: {
    label: String,
    placeholder: String,
    required: Boolean,
    value: String,
    type: String,
    readonly: Boolean,
    minLength: Number,
    maxLength: Number,
    length: Number,
    colClass: String,
    autoFocus: Boolean,
    state: String
  },
  data() {
    return {
      localValue: '',
      validate: false,
      checked: false
    };
  },
  methods: {
    onBlur: function (event) {
      this.validate = true;
      this.$refs.field.validate();
      this.$emit('blur', event);
    },
    onFocus: function (event) {
      this.checked = true;
      this.$emit('focus', event);
    },
    getRules: function () {
      const rules = [];
      if (!this.required) {
        rules.push((val) => {
          if (val && this.state && !this.getRegex(this.state).test(val.replace(/\s/g, '').trim())) {
            return 'invalid card number';
          }
          return true;
        });
      }
      if (this.required) {
        rules.push((val) => {
          if (!val || val == '') {
            return 'Please enter your details';
          }
          if (!this.checked) {
            return 'Please make sure your details are entered correctly';
          }
          if (val && this.state && this.getRegex(this.state) && !this.getRegex(this.state).test(val.replace(/\s/g, '').trim())) {
            return 'invalid card number';
          }
          return true;
        });
      }
      return rules;
    },
    newDriverLicenseCardNumberRegex(minLength, maxLength, isAlphaNumeric = false) {
      return new RegExp(`^[${isAlphaNumeric ? 'a-zA-Z' : ''}\\d]{${minLength},${maxLength}}$`);
    },
    getRegex(stateName) {
      const states = {
        NSW: this.newDriverLicenseCardNumberRegex(10, 10),
        NT: this.newDriverLicenseCardNumberRegex(6, 8),
        ACT: this.newDriverLicenseCardNumberRegex(10, 10, true),
        QLD: this.newDriverLicenseCardNumberRegex(10, 10, true),
        SA: this.newDriverLicenseCardNumberRegex(9, 9, true),
        TAS: this.newDriverLicenseCardNumberRegex(9, 9, true),
        VIC: this.newDriverLicenseCardNumberRegex(8, 8, true),
        WA: this.newDriverLicenseCardNumberRegex(8, 10, true)
      };
      return states[stateName];
    }
  },
  created() {
    this.localValue = this.value;
    this.$watch('localValue', (value) => {
      this.$emit('input', value);
    });
  },
  components: { QInput },
  mounted() {
    this.validate = true;
    this.$refs.field.validate();
  }
};
</script>
